var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var cio_config = require("cio-config");
var PadReplicatorData = require('./padReplicatorData.js');

var QuadPadReplicatorData = function (position, angle, totalNumberOfVerticalPads, totalNumberOfHorizontalPads, horizontalLeadToLeadPitch, verticalLeadToLeadPitch, pinPitch, motif) {
    PadReplicatorData.call(this, position, angle, totalNumberOfVerticalPads, totalNumberOfHorizontalPads, horizontalLeadToLeadPitch, pinPitch, motif);

    //pitch between leads at top and bottom sides
    this.verticalLeadToLeadPitch = this.value("verticalLeadToLeadPitch", true, cio_config.types.positive_float.validator);

    this.nonTransformedSegmentedGeometry.addTrigger(this.verticalLeadToLeadPitch);

    if(verticalLeadToLeadPitch != undefined) this.verticalLeadToLeadPitch(verticalLeadToLeadPitch);
};
lib_core.inherit(QuadPadReplicatorData, PadReplicatorData);
lib_core.JsonParser.registerClass(QuadPadReplicatorData, "QuadPadReplicatorData");

module.exports = QuadPadReplicatorData;

/*QuadPadReplicatorData.prototype.populateNameList = function() {
    var self = this;

    for (var i = 0, totalPadCount = self.nCol() + self.nRow(); i < totalPadCount; i++) {
        self.nameList.push(self.nameManagedType.getProposal(i + 1));
    }
};*/

QuadPadReplicatorData.prototype.getPads = function(absolutePositions) {
    var self = this;

    //this check is needed
    if(!this.motif()) return [];

    var pad,
        pads = [],
        rowIdx,
        i;

    //left pads
    for (i = 0; i < this.nRow() / 2; i++) {
        rowIdx = i % (this.nRow() / 2);

        pad = this.motif().clone();
        pad.move(new lib_geometry.Coord(-0.5 * this.hPitch(), ((this.nRow() / 2 - 1) / 2 - rowIdx) * this.vPitch()));
        pads.push(pad);
    }

    //bottom pads
    for (i = 0; i < this.nCol() / 2; i++) {
        rowIdx = i % (this.nCol() / 2);

        pad = this.motif().clone();
        pad.rotate(90);
        pad.move(new lib_geometry.Coord((-(this.nCol() / 2 - 1) / 2 + rowIdx) * this.vPitch(), -0.5 * this.verticalLeadToLeadPitch()));
        pads.push(pad);
    }

    //right pads
    for (i = 0; i < this.nRow() / 2; i++) {
        rowIdx = this.nRow() / 2 - 1 - i % (this.nRow() / 2);

        pad = this.motif().clone();
        pad.move(new lib_geometry.Coord(0.5 * this.hPitch(), ((this.nRow() / 2 - 1) / 2 - rowIdx) * this.vPitch()));
        pads.push(pad);
    }

    //top pads
    for (i = 0; i < this.nCol() / 2; i++) {
        rowIdx = this.nCol() / 2 - 1 - i % (this.nCol() / 2);

        pad = this.motif().clone();
        pad.rotate(90);
        pad.move(new lib_geometry.Coord((-(this.nCol() / 2 - 1) / 2 + rowIdx) * this.vPitch(), 0.5 * this.verticalLeadToLeadPitch()));
        pads.push(pad);
    }

    //update pad names
    self.nameList.forEach(function(idx, name) {
        if (pads[idx]) pads[idx].name(name);
    });

    //apply transform on pads if absolute position flag is true
    if (absolutePositions) {
        pads.forEach(function(pad) {
            pad.move(self.pos());
            pad.rotate(self.angle(), self.pos());
        });
    }

    return pads;
};

QuadPadReplicatorData.prototype._getNonTransformedSegmentedGeometry = function (precision) {
    var self = this;
    var pads = self.getPads(false),
        boundingBox = null;

    pads.forEach(function(pad) {
        var padBB = pad.boundingBox && pad.boundingBox();
        if(padBB) boundingBox = padBB.merge(boundingBox);
    });

    console.assert(boundingBox);

    return boundingBox.getPoly();
};
